import { render, staticRenderFns } from "./SigEditor.vue?vue&type=template&id=6b27979c&scoped=true"
import script from "./SigEditor.vue?vue&type=script&lang=js"
export * from "./SigEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b27979c",
  null
  
)

export default component.exports